import React from 'react';
import NoteModal from '@src/components/NoteModal/NoteModal';

const Wrapper = (props) => <NoteModal {...props} />;

export default Wrapper;
